import { message } from 'antd'
import * as ACTIONS from "app/actions/SignatureActions"

const initialState = {
    isLoadingSignature: false,
    listSignature: [],
    listContrat: [],
    listCategory: [],
    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },
    isSaving: false,
    isDeleting: false,
    filters: {
        EmployeeId: [],
        IdCategory: [],
    }

}

export const SignatureReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.GET_SIGNATURE_CONTRACTS_RQ:
            return {
                ...state,
                isLoadingSignature: true,
            };
        case ACTIONS.GET_SIGNATURE_CONTRACTS_SC:
            return {
                ...state,
                listContrat: action.payload,
                isLoadingSignature: false,
            };
        case ACTIONS.GET_SIGNATURE_CONTRACTS_FL:
            return {
                ...state,
                listContrat: [],
                isLoadingSignature: false,
            };
        case ACTIONS.GET_SIGNATURE_CATEGORY_RQ:
            return {
                ...state,
                isLoadingSignature: true,
            };
        case ACTIONS.GET_SIGNATURE_CATEGORY_SC:
            return {
                ...state,
                listCategory: action.payload,
                isLoadingSignature: false,
            };
        case ACTIONS.GET_SIGNATURE_CATEGORY_FL:
            return {
                ...state,
                listCategory: [],
                isLoadingSignature: false,
            };
        case ACTIONS.INSUPD_SIGNATURE_RQ:
            return {
                ...state,
                isSaving: true,
            };
        case ACTIONS.INSUPD_SIGNATURE_SC:
            message.success(action.payload);
            return {
                ...state,
                isSaving: false,
            };
        case ACTIONS.INSUPD_SIGNATURE_FL:
            message.error(action.payload);
            return {
                ...state,
                isSaving: false,
            };
        case ACTIONS.DEL_SIGNATURE_RQ:
            return {
                ...state,
                isDeleting: true,
            };
        case ACTIONS.DEL_SIGNATURE_SC:
            message.success("Firmante Eliminado");
            return {
                ...state,
                isDeleting: false,
            };
        case ACTIONS.DEL_SIGNATURE_FL:
            message.error(action.payload);
            return {
                ...state,
                isDeleting: false,
            };
        case ACTIONS.FETCH_SIGNATURE_RQ:
            return {
                ...state,
                isLoadingSignature: true,
            };
        case ACTIONS.FETCH_SIGNATURE_SC:
            return {
                ...state,
                listSignature: action.payload,
                isLoadingSignature: false,
                pagination: { ...state.pagination, total: action.payload.length > 0 ? action.payload[0].totalCount : 0 }
            };
        case ACTIONS.FETCH_SIGNATURE_FL:
            return {
                ...state,
                listSignature: [],
                isLoadingSignature: false,
            };
        case ACTIONS.CLEAR_REDUCER:
            return initialState;
        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }

        case ACTIONS.FILTER_SIGNATURE_RQ:
            return {
                ...state,
                isLoadingSignature: true,
            };
        case ACTIONS.FILTER_SIGNATURE_SC:
            let { signatoryEmployee, signatoryCategory } = action.payload;
            let filters = {
                EmployeeId: signatoryEmployee,
                IdCategory: signatoryCategory,
            }

            return {
                ...state,
                filters,
                isLoadingSignature: false,
            };
        case ACTIONS.FILTER_SIGNATURE_FL:
            return {
                ...state,
                filters: {
                    EmployeeId: [],
                    IdCategory: [],
                },
                isLoadingSignature: false,
            };
        default:
            return state;


    }
}